import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { BE_API_AUTH_URL } from '../constants/app.constants';
import { AuthService } from './auth.service';

export interface AuditLogActor {
  userId: string | null;
  email: string | null;
  displayName: string | null;
  role: string | null;
  companyRole: string | null;
  effectivePermissions: string[];
  isPlatformAdmin: boolean;
}

export interface AuditLogEntry {
  _id: string;
  occurredAt: string;
  scope: 'company' | 'platform' | 'public' | 'system';
  companyId: string | null;
  tenantId?: string | null;
  action: string;
  resourceType: string;
  resourceId: string;
  resourceLabel: string | null;
  actor: AuditLogActor;
  logKind?: 'audit' | 'activity';
  status: 'success';
  target?: any;
  changes?: any;
  bulk?: any;
  context?: any;
  meta?: any;
  referenceLabels?: {
    qrPosterTemplates?: Record<string, string>;
  };
}

export interface AuditLogListResponse {
  items: AuditLogEntry[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}

export interface AuditLogFilters {
  page?: number;
  pageSize?: number;
  search?: string;
  actor?: string;
  logKind?: string;
  action?: string;
  resourceType?: string;
  resourceId?: string;
  dateFrom?: string;
  dateTo?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  listAuditLogs(filters: AuditLogFilters): Observable<AuditLogListResponse> {
    let params = new HttpParams();

    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== null && typeof value !== 'undefined' && String(value).trim() !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http
      .get<AuditLogListResponse>(`${BE_API_AUTH_URL}/audit-logs`, {
        headers: this.authService.createAuthorizationHeader(),
        params,
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getAuditLog(id: string): Observable<AuditLogEntry> {
    return this.http
      .get<AuditLogEntry>(`${BE_API_AUTH_URL}/audit-logs/${id}`, {
        headers: this.authService.createAuthorizationHeader(),
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
